import { createStore, compose } from "redux";
import { reactReduxFirebase } from "react-redux-firebase";
import { reduxFirestore } from "redux-firestore";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

//Import the firebase configuration - currently test database
import firebaseConfig from "../firebase/firebaseConfig.js";

//Import reducers
import { rootReducer } from "./reducers/reducer";

//Initialize database
firebase.initializeApp(firebaseConfig);
firebase.firestore();

//Connecting firestore to redux
const enhancers = [
  reduxFirestore(firebase),
  //This will be used for authenticaton - users are going to be stored in the firestore database
  reactReduxFirebase(firebase, {
    userProfile: "authedUsers",
    useFirestoreForProfile: true
  }),
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
];

const composedEnhancers = compose(...enhancers);

const store = createStore(rootReducer, composedEnhancers);

export default store;
